import { Component, Input, OnInit, Output, ViewChild, EventEmitter, OnChanges } from '@angular/core';

@Component({
    selector: 'input-select-search',
    templateUrl: './input-select-search.component.html',
    styleUrls: ['./input-select-search.component.scss'],
})
export class InputSelectSearchComponent implements OnInit, OnChanges {

    @Input('data') Data: { Code: string, Description: string, Checked?: boolean }[] = [];
    @Input('disabled') IsDisabled: boolean = false;
    @Input('value') FieldValue: string = '';

    @Input('textPlaceholder') Placeholder: string = 'indique o valor';
    @Input('textHelper') HelperText: string = '';

    @ViewChild('popover') popover;

    @Output('callback') callback: EventEmitter<any> = new EventEmitter<any>();

    public IsOpen: boolean = false;

    constructor() { }

    ngOnInit() {
        this.parseData();
    }

    ngOnChanges() {
        this.parseData();
    }

    /** Itens atualmente selecionados (derivado de Data — sempre coerente). */
    get Selected(): any[] {
        return this.Data?.filter(it => it?.Checked) || [];
    }

    /** Resumo mostrado no campo (a descrição fica nos chips por baixo). */
    get SummaryText(): string {
        const n = this.Selected.length;
        return n ? `${n} selecionado${n === 1 ? '' : 's'}` : '';
    }

    private parseData() {
        const temp = (this.FieldValue || '').split(',').map(it => it.trim()).filter(Boolean);

        this.Data?.forEach(el => {
            el['Checked'] = temp.some(it => it === el.Code);
        });
    }

    private recompute() {
        this.FieldValue = this.Selected.map(it => it?.Code).join(', ');

        if (this.callback)
            this.callback.emit(this.FieldValue);
    }

    public trackByFn(index, item) {
        return item?.Code ?? index;
    }

    /** Altura da lista ajustada ao conteúdo (até 8 linhas visíveis, depois faz scroll). */
    public ViewportHeight(count: number): number {
        if (!count) return 72; // espaço para "sem resultados"
        return Math.min(count, 8) * 40;
    }

    public OnPresentPopover(e: Event) {
        if (this.IsDisabled) return;

        this.popover.event = e;
        this.IsOpen = true;
    }

    /** Alterna a seleção — chamado pelo clique na linha inteira. */
    public Toggle(item) {
        if (this.IsDisabled) return;

        item['Checked'] = !item['Checked'];
        this.recompute();
    }

    /** Remove um item selecionado (chip). */
    public Remove(item) {
        if (this.IsDisabled) return;

        item['Checked'] = false;
        this.recompute();
    }
}
